import {
  BiLogoLinkedin,
  BiLogoTelegram,
  BiLogoGmail,
  BiLogoGithub,
  BiSolidPhoneCall,
} from "react-icons/bi";


export const IconsLinkedin = () => <BiLogoLinkedin size={50} className='contacts-icon' />
export const IconsTelegram = () => <BiLogoTelegram size={50} className='contacts-icon' />
export const IconsGmail = () => <BiLogoGmail size={50} className='contacts-icon' />
export const IconsGithub = () => <BiLogoGithub size={50} className='contacts-icon' />
export const IconsPhone = () => <BiSolidPhoneCall size={50} className='contacts-icon'/>